import { FC } from 'react'

import { ChevronDownIcon } from 'components/icons'
import Dropdown, { DropdownType } from './forms/Dropdown'

type TextDropdownType = DropdownType

const TextDropdown: FC<TextDropdownType> = ({ children, ...props }) => {
  return (
    <Dropdown {...props}>
      <div
        onClick={() => props.setShow(!props.show)}
        className='flex-row cursor-pointer h-100 d-flex align-items-center'
      >
        <div className='me-2 fw-semibold user-select-none'>{children}</div>
        <ChevronDownIcon className='input-icon' />
      </div>
    </Dropdown>
  )
}

export default TextDropdown
